<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div class="text-muted small">
        <span>
            {{ programInfo.statusFormatted() }}
            <span :class="[programInfo.statusColorClass()]" class="dot"></span>
        </span>
    </div>
</template>

<script>
    import ProgramInfo from "@/core/js/model/Program/ProgramInfo";

	export default {
        name: "ProgramInfoStatus",
		props: {
			programInfo: { type: ProgramInfo, default: () => ({}) },
		},

	}
</script>

<style>

</style>
